import type { SalesChannel } from "#imports";
import {
  useBasketStore,
  useBusinessStore,
  useCustomerStore,
  useDirectBackend,
  useFeatureMatrixStore,
  useOutletStore,
} from "#imports";

export const useSalesChannel = () => {
  const businessStore = useBusinessStore();
  const basketStore = useBasketStore();
  const featureMatrixStore = useFeatureMatrixStore();
  const outletStore = useOutletStore();
  const customerStore = useCustomerStore();

  const { bootstrapRepo } = useDirectBackend();

  const setSalesChannel = async (salesChannel: SalesChannel) => {
    if (businessStore.salesChannel === salesChannel) return;

    bootstrapRepo.startWo({
      domain: window.location.hostname,
      salesChannel: `${salesChannel}`,
    });

    if (basketStore.isLoaded) {
      basketStore.reset();
    }

    if (outletStore.isLoaded) {
      outletStore.reset();
    }

    await Promise.all([
      businessStore.patch({ salesChannel }),
      basketStore.patch({ salesChannel }),
      customerStore.isLogged
        ? customerStore.syncAddresses(businessStore.id)
        : Promise.resolve(),
      featureMatrixStore.load(businessStore.id, salesChannel),
    ]);
  };

  return {
    setSalesChannel,
  };
};
